import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import {
  ServerFile1t91jzpzoixwe as ServerFile,
  ServerFile__hashCode_impl_qj0ii515d8xjm2d7n5l as ServerFile__hashCode_impl_qj0ii5,
} from '../../files/ServerFile.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../../lightningdb/HasId.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../DefaultClock.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance } from '../../../UUID.js.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.oauth.OauthResponse', this, 5);
        tmp0_serialDesc.a1b('access_token', false);
        tmp0_serialDesc.a1b('scope', true);
        tmp0_serialDesc.a1b('token_type', true);
        tmp0_serialDesc.a1b('id_token', true);
        tmp0_serialDesc.a1b('refresh_token', true);
        this.y4b_1 = tmp0_serialDesc;
      }
      z4b(encoder, value) {
        var tmp0_desc = this.y4b_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.a4c_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.b4c_1 === '')) {
          tmp1_output.a15(tmp0_desc, 1, value.b4c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.c4c_1 === 'Bearer')) {
          tmp1_output.a15(tmp0_desc, 2, value.c4c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.d4c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, StringSerializer_getInstance(), value.d4c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.e4c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, StringSerializer_getInstance(), value.e4c_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.z4b(encoder, value instanceof OauthResponse() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.y4b_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.l13(tmp0_desc);
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return OauthResponse().f4c(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.y4b_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var OauthResponseClass;
function OauthResponse() {
  if (OauthResponseClass === VOID) {
    class $ {
      toString() {
        return 'OauthResponse(access_token=' + this.a4c_1 + ', scope=' + this.b4c_1 + ', token_type=' + this.c4c_1 + ', id_token=' + this.d4c_1 + ', refresh_token=' + this.e4c_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.a4c_1);
        result = imul(result, 31) + getStringHashCode(this.b4c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.c4c_1) | 0;
        result = imul(result, 31) + (this.d4c_1 == null ? 0 : getStringHashCode(this.d4c_1)) | 0;
        result = imul(result, 31) + (this.e4c_1 == null ? 0 : getStringHashCode(this.e4c_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OauthResponse()))
          return false;
        if (!(this.a4c_1 === other.a4c_1))
          return false;
        if (!(this.b4c_1 === other.b4c_1))
          return false;
        if (!(this.c4c_1 === other.c4c_1))
          return false;
        if (!(this.d4c_1 == other.d4c_1))
          return false;
        if (!(this.e4c_1 == other.e4c_1))
          return false;
        return true;
      }
      static f4c(seen0, access_token, scope, token_type, id_token, refresh_token, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance().y4b_1);
        }
        var $this = createThis(this);
        $this.a4c_1 = access_token;
        if (0 === (seen0 & 2))
          $this.b4c_1 = '';
        else
          $this.b4c_1 = scope;
        if (0 === (seen0 & 4))
          $this.c4c_1 = 'Bearer';
        else
          $this.c4c_1 = token_type;
        if (0 === (seen0 & 8))
          $this.d4c_1 = null;
        else
          $this.d4c_1 = id_token;
        if (0 === (seen0 & 16))
          $this.e4c_1 = null;
        else
          $this.e4c_1 = refresh_token;
        return $this;
      }
    }
    initMetadataForClass($, 'OauthResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    OauthResponseClass = $;
  }
  return OauthResponseClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.oauth.OauthTokenRequest', this, 6);
        tmp0_serialDesc.a1b('code', true);
        tmp0_serialDesc.a1b('refresh_token', true);
        tmp0_serialDesc.a1b('client_id', false);
        tmp0_serialDesc.a1b('client_secret', false);
        tmp0_serialDesc.a1b('redirect_uri', true);
        tmp0_serialDesc.a1b('grant_type', true);
        this.g4c_1 = tmp0_serialDesc;
      }
      h4c(encoder, value) {
        var tmp0_desc = this.g4c_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !(value.i4c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 0, StringSerializer_getInstance(), value.i4c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.j4c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.j4c_1);
        }
        tmp1_output.a15(tmp0_desc, 2, value.k4c_1);
        tmp1_output.a15(tmp0_desc, 3, value.l4c_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.m4c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, StringSerializer_getInstance(), value.m4c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.n4c_1 === 'authorization_code')) {
          tmp1_output.a15(tmp0_desc, 5, value.n4c_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.h4c(encoder, value instanceof OauthTokenRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.g4c_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.l13(tmp0_desc);
        if (tmp10_input.a14()) {
          tmp4_local0 = tmp10_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp10_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp10_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp10_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp10_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp10_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp10_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp10_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp10_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp10_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp10_input.m13(tmp0_desc);
        return OauthTokenRequest().o4c(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      az() {
        return this.g4c_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var OauthTokenRequestClass;
function OauthTokenRequest() {
  if (OauthTokenRequestClass === VOID) {
    class $ {
      toString() {
        return 'OauthTokenRequest(code=' + this.i4c_1 + ', refresh_token=' + this.j4c_1 + ', client_id=' + this.k4c_1 + ', client_secret=' + this.l4c_1 + ', redirect_uri=' + this.m4c_1 + ', grant_type=' + this.n4c_1 + ')';
      }
      hashCode() {
        var result = this.i4c_1 == null ? 0 : getStringHashCode(this.i4c_1);
        result = imul(result, 31) + (this.j4c_1 == null ? 0 : getStringHashCode(this.j4c_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.k4c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l4c_1) | 0;
        result = imul(result, 31) + (this.m4c_1 == null ? 0 : getStringHashCode(this.m4c_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.n4c_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OauthTokenRequest()))
          return false;
        if (!(this.i4c_1 == other.i4c_1))
          return false;
        if (!(this.j4c_1 == other.j4c_1))
          return false;
        if (!(this.k4c_1 === other.k4c_1))
          return false;
        if (!(this.l4c_1 === other.l4c_1))
          return false;
        if (!(this.m4c_1 == other.m4c_1))
          return false;
        if (!(this.n4c_1 === other.n4c_1))
          return false;
        return true;
      }
      static o4c(seen0, code, refresh_token, client_id, client_secret, redirect_uri, grant_type, serializationConstructorMarker) {
        if (!(12 === (12 & seen0))) {
          throwMissingFieldException(seen0, 12, $serializer_getInstance_0().g4c_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.i4c_1 = null;
        else
          $this.i4c_1 = code;
        if (0 === (seen0 & 2))
          $this.j4c_1 = null;
        else
          $this.j4c_1 = refresh_token;
        $this.k4c_1 = client_id;
        $this.l4c_1 = client_secret;
        if (0 === (seen0 & 16))
          $this.m4c_1 = null;
        else
          $this.m4c_1 = redirect_uri;
        if (0 === (seen0 & 32))
          $this.n4c_1 = 'authorization_code';
        else
          $this.n4c_1 = grant_type;
        return $this;
      }
    }
    initMetadataForClass($, 'OauthTokenRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    OauthTokenRequestClass = $;
  }
  return OauthTokenRequestClass;
}
function OauthClient$Companion$$childSerializers$_anonymous__b9q3ag() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function OauthClient$Companion$$childSerializers$_anonymous__b9q3ag_0() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
function OauthClient$Companion$$childSerializers$_anonymous__b9q3ag_1() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_2());
}
function OauthClient$Companion$$childSerializers$_anonymous__b9q3ag_2() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, OauthClient$Companion$$childSerializers$_anonymous__b9q3ag);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, OauthClient$Companion$$childSerializers$_anonymous__b9q3ag_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, OauthClient$Companion$$childSerializers$_anonymous__b9q3ag_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.o2m_1 = [null, null, tmp_1, tmp_3, tmp_5, lazy(tmp_6, OauthClient$Companion$$childSerializers$_anonymous__b9q3ag_2)];
      }
      k2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 === VOID)
    new (Companion_1())();
  return Companion_instance_2;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.oauth.OauthClient', this, 6);
        tmp0_serialDesc.a1b('_id', false);
        tmp0_serialDesc.a1b('niceName', false);
        tmp0_serialDesc.a1b('logo', true);
        tmp0_serialDesc.a1b('scopes', true);
        tmp0_serialDesc.a1b('secrets', true);
        tmp0_serialDesc.a1b('redirectUris', true);
        this.p4c_1 = tmp0_serialDesc;
      }
      q4c(encoder, value) {
        var tmp0_desc = this.p4c_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().o2m_1;
        tmp1_output.a15(tmp0_desc, 0, value.t2m_1);
        tmp1_output.a15(tmp0_desc, 1, value.u2m_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 2)) {
          tmp = true;
        } else {
          var tmp_0 = value.v2m_1;
          tmp = !((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = tmp2_cached[2].f2();
          var tmp_2 = value.v2m_1;
          tmp1_output.d15(tmp0_desc, 2, tmp_1, tmp_2 == null ? null : new (ServerFile())(tmp_2));
        }
        var tmp_3;
        if (tmp1_output.h15(tmp0_desc, 3)) {
          tmp_3 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp_3 = !equals(value.w2m_1, tmp$ret$0);
        }
        if (tmp_3) {
          tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.w2m_1);
        }
        var tmp_4;
        if (tmp1_output.h15(tmp0_desc, 4)) {
          tmp_4 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$1 = emptySet();
          tmp_4 = !equals(value.x2m_1, tmp$ret$1);
        }
        if (tmp_4) {
          tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.x2m_1);
        }
        var tmp_5;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp_5 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$2 = emptySet();
          tmp_5 = !equals(value.y2m_1, tmp$ret$2);
        }
        if (tmp_5) {
          tmp1_output.c15(tmp0_desc, 5, tmp2_cached[5].f2(), value.y2m_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.q4c(encoder, value instanceof OauthClient() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.p4c_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.l13(tmp0_desc);
        var tmp11_cached = Companion_getInstance_2().o2m_1;
        if (tmp10_input.a14()) {
          tmp4_local0 = tmp10_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp10_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp = tmp11_cached[2].f2();
          var tmp_0 = tmp6_local2;
          var tmp_1 = tmp10_input.z13(tmp0_desc, 2, tmp, tmp_0 == null ? null : new (ServerFile())(tmp_0));
          tmp6_local2 = tmp_1 == null ? null : tmp_1.l2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp10_input.x13(tmp0_desc, 3, tmp11_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp10_input.x13(tmp0_desc, 4, tmp11_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp10_input.x13(tmp0_desc, 5, tmp11_cached[5].f2(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp10_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp10_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_2 = tmp11_cached[2].f2();
                var tmp_3 = tmp6_local2;
                var tmp_4 = tmp10_input.z13(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new (ServerFile())(tmp_3));
                tmp6_local2 = tmp_4 == null ? null : tmp_4.l2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp10_input.x13(tmp0_desc, 3, tmp11_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp10_input.x13(tmp0_desc, 4, tmp11_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp10_input.x13(tmp0_desc, 5, tmp11_cached[5].f2(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp10_input.m13(tmp0_desc);
        return OauthClient().r4c(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      az() {
        return this.p4c_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_2().o2m_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(tmp0_cached[2].f2()), tmp0_cached[3].f2(), tmp0_cached[4].f2(), tmp0_cached[5].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var OauthClientClass;
function OauthClient() {
  if (OauthClientClass === VOID) {
    class $ {
      constructor(_id, niceName, logo, scopes, secrets, redirectUris) {
        Companion_getInstance_2();
        logo = logo === VOID ? null : logo;
        var tmp;
        if (scopes === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = scopes;
        }
        scopes = tmp;
        var tmp_0;
        if (secrets === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        } else {
          tmp_0 = secrets;
        }
        secrets = tmp_0;
        var tmp_1;
        if (redirectUris === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_1 = emptySet();
        } else {
          tmp_1 = redirectUris;
        }
        redirectUris = tmp_1;
        this.t2m_1 = _id;
        this.u2m_1 = niceName;
        this.v2m_1 = logo;
        this.w2m_1 = scopes;
        this.x2m_1 = secrets;
        this.y2m_1 = redirectUris;
      }
      f40() {
        return this.t2m_1;
      }
      s4c(_id, niceName, logo, scopes, secrets, redirectUris) {
        return new (OauthClient())(_id, niceName, logo, scopes, secrets, redirectUris);
      }
      a2n(_id, niceName, logo, scopes, secrets, redirectUris, $super) {
        _id = _id === VOID ? this.t2m_1 : _id;
        niceName = niceName === VOID ? this.u2m_1 : niceName;
        logo = logo === VOID ? this.v2m_1 : logo;
        scopes = scopes === VOID ? this.w2m_1 : scopes;
        secrets = secrets === VOID ? this.x2m_1 : secrets;
        redirectUris = redirectUris === VOID ? this.y2m_1 : redirectUris;
        var tmp;
        if ($super === VOID) {
          tmp = this.s4c(_id, niceName, logo, scopes, secrets, redirectUris);
        } else {
          var tmp_0 = $super.s4c;
          var tmp_1 = logo;
          tmp = tmp_0.call(this, _id, niceName, tmp_1 == null ? null : new (ServerFile())(tmp_1), scopes, secrets, redirectUris);
        }
        return tmp;
      }
      toString() {
        var tmp = this.v2m_1;
        return 'OauthClient(_id=' + this.t2m_1 + ', niceName=' + this.u2m_1 + ', logo=' + toString_0(tmp == null ? null : new (ServerFile())(tmp)) + ', scopes=' + toString(this.w2m_1) + ', secrets=' + toString(this.x2m_1) + ', redirectUris=' + toString(this.y2m_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.t2m_1);
        result = imul(result, 31) + getStringHashCode(this.u2m_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.v2m_1;
        if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ServerFile__hashCode_impl_qj0ii5(this.v2m_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + hashCode(this.w2m_1) | 0;
        result = imul(result, 31) + hashCode(this.x2m_1) | 0;
        result = imul(result, 31) + hashCode(this.y2m_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OauthClient()))
          return false;
        if (!(this.t2m_1 === other.t2m_1))
          return false;
        if (!(this.u2m_1 === other.u2m_1))
          return false;
        var tmp = this.v2m_1;
        var tmp_0 = tmp == null ? null : new (ServerFile())(tmp);
        var tmp_1 = other.v2m_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ServerFile())(tmp_1)))
          return false;
        if (!equals(this.w2m_1, other.w2m_1))
          return false;
        if (!equals(this.x2m_1, other.x2m_1))
          return false;
        if (!equals(this.y2m_1, other.y2m_1))
          return false;
        return true;
      }
      static r4c(seen0, _id, niceName, logo, scopes, secrets, redirectUris, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_1().p4c_1);
        }
        var $this = createThis(this);
        $this.t2m_1 = _id;
        $this.u2m_1 = niceName;
        if (0 === (seen0 & 4))
          $this.v2m_1 = null;
        else
          $this.v2m_1 = logo;
        if (0 === (seen0 & 8)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.w2m_1 = emptySet();
        } else
          $this.w2m_1 = scopes;
        if (0 === (seen0 & 16)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_0.x2m_1 = emptySet();
        } else
          $this.x2m_1 = secrets;
        if (0 === (seen0 & 32)) {
          var tmp_1 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_1.y2m_1 = emptySet();
        } else
          $this.y2m_1 = redirectUris;
        return $this;
      }
    }
    initMetadataForClass($, 'OauthClient', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_1});
    OauthClientClass = $;
  }
  return OauthClientClass;
}
function OauthClientSecret$Companion$$childSerializers$_anonymous__vxi3fc() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function OauthClientSecret$Companion$$childSerializers$_anonymous__vxi3fc_0() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, OauthClientSecret$Companion$$childSerializers$_anonymous__vxi3fc);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.d2o_1 = [tmp_1, null, null, lazy(tmp_2, OauthClientSecret$Companion$$childSerializers$_anonymous__vxi3fc_0)];
      }
      k2a() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 === VOID)
    new (Companion_2())();
  return Companion_instance_3;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.oauth.OauthClientSecret', this, 4);
        tmp0_serialDesc.a1b('createdAt', true);
        tmp0_serialDesc.a1b('masked', false);
        tmp0_serialDesc.a1b('secretHash', false);
        tmp0_serialDesc.a1b('disabledAt', true);
        this.t4c_1 = tmp0_serialDesc;
      }
      u4c(encoder, value) {
        var tmp0_desc = this.t4c_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_3().d2o_1;
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 0)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance).b1m();
          tmp = !value.k2o_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.k2o_1);
        }
        tmp1_output.a15(tmp0_desc, 1, value.l2o_1);
        tmp1_output.a15(tmp0_desc, 2, value.m2o_1);
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.n2o_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.n2o_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.u4c(encoder, value instanceof OauthClientSecret() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.t4c_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        var tmp9_cached = Companion_getInstance_3().d2o_1;
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, tmp9_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, tmp9_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return OauthClientSecret().v4c(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.t4c_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_3().d2o_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(tmp0_cached[3].f2())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var OauthClientSecretClass;
function OauthClientSecret() {
  if (OauthClientSecretClass === VOID) {
    class $ {
      constructor(createdAt, masked, secretHash, disabledAt) {
        Companion_getInstance_3();
        var tmp;
        if (createdAt === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).b1m();
        } else {
          tmp = createdAt;
        }
        createdAt = tmp;
        disabledAt = disabledAt === VOID ? null : disabledAt;
        this.k2o_1 = createdAt;
        this.l2o_1 = masked;
        this.m2o_1 = secretHash;
        this.n2o_1 = disabledAt;
      }
      w4c(createdAt, masked, secretHash, disabledAt) {
        return new (OauthClientSecret())(createdAt, masked, secretHash, disabledAt);
      }
      p2o(createdAt, masked, secretHash, disabledAt, $super) {
        createdAt = createdAt === VOID ? this.k2o_1 : createdAt;
        masked = masked === VOID ? this.l2o_1 : masked;
        secretHash = secretHash === VOID ? this.m2o_1 : secretHash;
        disabledAt = disabledAt === VOID ? this.n2o_1 : disabledAt;
        return $super === VOID ? this.w4c(createdAt, masked, secretHash, disabledAt) : $super.w4c.call(this, createdAt, masked, secretHash, disabledAt);
      }
      toString() {
        return 'OauthClientSecret(createdAt=' + this.k2o_1.toString() + ', masked=' + this.l2o_1 + ', secretHash=' + this.m2o_1 + ', disabledAt=' + toString_0(this.n2o_1) + ')';
      }
      hashCode() {
        var result = this.k2o_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.l2o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.m2o_1) | 0;
        result = imul(result, 31) + (this.n2o_1 == null ? 0 : this.n2o_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OauthClientSecret()))
          return false;
        if (!this.k2o_1.equals(other.k2o_1))
          return false;
        if (!(this.l2o_1 === other.l2o_1))
          return false;
        if (!(this.m2o_1 === other.m2o_1))
          return false;
        if (!equals(this.n2o_1, other.n2o_1))
          return false;
        return true;
      }
      static v4c(seen0, createdAt, masked, secretHash, disabledAt, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(6 === (6 & seen0))) {
          throwMissingFieldException(seen0, 6, $serializer_getInstance_2().t4c_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.k2o_1 = get_default(Companion_instance).b1m();
        } else
          $this.k2o_1 = createdAt;
        $this.l2o_1 = masked;
        $this.m2o_1 = secretHash;
        if (0 === (seen0 & 8))
          $this.n2o_1 = null;
        else
          $this.n2o_1 = disabledAt;
        return $this;
      }
    }
    initMetadataForClass($, 'OauthClientSecret', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
    OauthClientSecretClass = $;
  }
  return OauthClientSecretClass;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.oauth.OauthCode', this, 3);
        tmp0_serialDesc.a1b('code', true);
        tmp0_serialDesc.a1b('error', true);
        tmp0_serialDesc.a1b('state', true);
        this.x4c_1 = tmp0_serialDesc;
      }
      y4c(encoder, value) {
        var tmp0_desc = this.x4c_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !(value.z4c_1 == null)) {
          tmp1_output.d15(tmp0_desc, 0, StringSerializer_getInstance(), value.z4c_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.a4d_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.a4d_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.b4d_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, StringSerializer_getInstance(), value.b4d_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.y4c(encoder, value instanceof OauthCode() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.x4c_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return OauthCode().c4d(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.x4c_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
var OauthCodeClass;
function OauthCode() {
  if (OauthCodeClass === VOID) {
    class $ {
      constructor(code, error, state) {
        code = code === VOID ? null : code;
        error = error === VOID ? null : error;
        state = state === VOID ? null : state;
        this.z4c_1 = code;
        this.a4d_1 = error;
        this.b4d_1 = state;
      }
      toString() {
        return 'OauthCode(code=' + this.z4c_1 + ', error=' + this.a4d_1 + ', state=' + this.b4d_1 + ')';
      }
      hashCode() {
        var result = this.z4c_1 == null ? 0 : getStringHashCode(this.z4c_1);
        result = imul(result, 31) + (this.a4d_1 == null ? 0 : getStringHashCode(this.a4d_1)) | 0;
        result = imul(result, 31) + (this.b4d_1 == null ? 0 : getStringHashCode(this.b4d_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OauthCode()))
          return false;
        if (!(this.z4c_1 == other.z4c_1))
          return false;
        if (!(this.a4d_1 == other.a4d_1))
          return false;
        if (!(this.b4d_1 == other.b4d_1))
          return false;
        return true;
      }
      static c4d(seen0, code, error, state, serializationConstructorMarker) {
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_3().x4c_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.z4c_1 = null;
        else
          $this.z4c_1 = code;
        if (0 === (seen0 & 2))
          $this.a4d_1 = null;
        else
          $this.a4d_1 = error;
        if (0 === (seen0 & 4))
          $this.b4d_1 = null;
        else
          $this.b4d_1 = state;
        return $this;
      }
    }
    initMetadataForClass($, 'OauthCode', OauthCode, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
    OauthCodeClass = $;
  }
  return OauthCodeClass;
}
function OauthCodeRequest$Companion$$childSerializers$_anonymous__2w2ee7() {
  return Companion_getInstance_7().k2a();
}
function OauthCodeRequest$Companion$$childSerializers$_anonymous__2w2ee7_0() {
  return Companion_getInstance_8().k2a();
}
function OauthCodeRequest$Companion$$childSerializers$_anonymous__2w2ee7_1() {
  return Companion_getInstance_6().k2a();
}
function OauthCodeRequest$Companion$$childSerializers$_anonymous__2w2ee7_2() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      constructor() {
        Companion_instance_5 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, OauthCodeRequest$Companion$$childSerializers$_anonymous__2w2ee7);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, OauthCodeRequest$Companion$$childSerializers$_anonymous__2w2ee7_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, OauthCodeRequest$Companion$$childSerializers$_anonymous__2w2ee7_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.t3j_1 = [null, null, null, null, null, tmp_1, tmp_3, null, tmp_5, null, lazy(tmp_6, OauthCodeRequest$Companion$$childSerializers$_anonymous__2w2ee7_2)];
      }
      k2a() {
        return $serializer_getInstance_4();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 === VOID)
    new (Companion_4())();
  return Companion_instance_5;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.oauth.OauthCodeRequest', this, 11);
        tmp0_serialDesc.a1b('response_type', false);
        tmp0_serialDesc.a1b('scope', false);
        tmp0_serialDesc.a1b('redirect_uri', false);
        tmp0_serialDesc.a1b('client_id', false);
        tmp0_serialDesc.a1b('state', true);
        tmp0_serialDesc.a1b('response_mode', true);
        tmp0_serialDesc.a1b('access_type', true);
        tmp0_serialDesc.a1b('include_granted_scopes', true);
        tmp0_serialDesc.a1b('prompt', true);
        tmp0_serialDesc.a1b('login_hint', true);
        tmp0_serialDesc.a1b('sessionExpiration', true);
        this.d4d_1 = tmp0_serialDesc;
      }
      e4d(encoder, value) {
        var tmp0_desc = this.d4d_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_5().t3j_1;
        tmp1_output.a15(tmp0_desc, 0, value.f4d_1);
        tmp1_output.a15(tmp0_desc, 1, value.g4d_1);
        tmp1_output.a15(tmp0_desc, 2, value.h4d_1);
        tmp1_output.a15(tmp0_desc, 3, value.i4d_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.j4d_1 === Companion_getInstance().k2p().toString())) {
          tmp1_output.a15(tmp0_desc, 4, value.j4d_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !value.k4d_1.equals(OauthResponseMode_form_post_getInstance())) {
          tmp1_output.c15(tmp0_desc, 5, tmp2_cached[5].f2(), value.k4d_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.l4d_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, tmp2_cached[6].f2(), value.l4d_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.m4d_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, BooleanSerializer_getInstance(), value.m4d_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.n4d_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, tmp2_cached[8].f2(), value.n4d_1);
        }
        if (tmp1_output.h15(tmp0_desc, 9) ? true : !(value.o4d_1 == null)) {
          tmp1_output.d15(tmp0_desc, 9, StringSerializer_getInstance(), value.o4d_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.p4d_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, tmp2_cached[10].f2(), value.p4d_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.e4d(encoder, value instanceof OauthCodeRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.d4d_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_input = decoder.l13(tmp0_desc);
        var tmp16_cached = Companion_getInstance_5().t3j_1;
        if (tmp15_input.a14()) {
          tmp4_local0 = tmp15_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp15_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp15_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp15_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp15_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp15_input.x13(tmp0_desc, 5, tmp16_cached[5].f2(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp15_input.z13(tmp0_desc, 6, tmp16_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp15_input.z13(tmp0_desc, 7, BooleanSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp15_input.z13(tmp0_desc, 8, tmp16_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp15_input.z13(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp15_input.z13(tmp0_desc, 10, tmp16_cached[10].f2(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp15_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp15_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp15_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp15_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp15_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp15_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp15_input.x13(tmp0_desc, 5, tmp16_cached[5].f2(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp15_input.z13(tmp0_desc, 6, tmp16_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp15_input.z13(tmp0_desc, 7, BooleanSerializer_getInstance(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp15_input.z13(tmp0_desc, 8, tmp16_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp15_input.z13(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp15_input.z13(tmp0_desc, 10, tmp16_cached[10].f2(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp15_input.m13(tmp0_desc);
        return OauthCodeRequest().q4d(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
      }
      az() {
        return this.d4d_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_5().t3j_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[5].f2(), get_nullable(tmp0_cached[6].f2()), get_nullable(BooleanSerializer_getInstance()), get_nullable(tmp0_cached[8].f2()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[10].f2())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var OauthCodeRequestClass;
function OauthCodeRequest() {
  if (OauthCodeRequestClass === VOID) {
    class $ {
      toString() {
        return 'OauthCodeRequest(response_type=' + this.f4d_1 + ', scope=' + this.g4d_1 + ', redirect_uri=' + this.h4d_1 + ', client_id=' + this.i4d_1 + ', state=' + this.j4d_1 + ', response_mode=' + this.k4d_1.toString() + ', access_type=' + toString_0(this.l4d_1) + ', include_granted_scopes=' + this.m4d_1 + ', prompt=' + toString_0(this.n4d_1) + ', login_hint=' + this.o4d_1 + ', sessionExpiration=' + toString_0(this.p4d_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.f4d_1);
        result = imul(result, 31) + getStringHashCode(this.g4d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h4d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.i4d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j4d_1) | 0;
        result = imul(result, 31) + this.k4d_1.hashCode() | 0;
        result = imul(result, 31) + (this.l4d_1 == null ? 0 : this.l4d_1.hashCode()) | 0;
        result = imul(result, 31) + (this.m4d_1 == null ? 0 : getBooleanHashCode(this.m4d_1)) | 0;
        result = imul(result, 31) + (this.n4d_1 == null ? 0 : this.n4d_1.hashCode()) | 0;
        result = imul(result, 31) + (this.o4d_1 == null ? 0 : getStringHashCode(this.o4d_1)) | 0;
        result = imul(result, 31) + (this.p4d_1 == null ? 0 : this.p4d_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OauthCodeRequest()))
          return false;
        if (!(this.f4d_1 === other.f4d_1))
          return false;
        if (!(this.g4d_1 === other.g4d_1))
          return false;
        if (!(this.h4d_1 === other.h4d_1))
          return false;
        if (!(this.i4d_1 === other.i4d_1))
          return false;
        if (!(this.j4d_1 === other.j4d_1))
          return false;
        if (!this.k4d_1.equals(other.k4d_1))
          return false;
        if (!equals(this.l4d_1, other.l4d_1))
          return false;
        if (!(this.m4d_1 == other.m4d_1))
          return false;
        if (!equals(this.n4d_1, other.n4d_1))
          return false;
        if (!(this.o4d_1 == other.o4d_1))
          return false;
        if (!equals(this.p4d_1, other.p4d_1))
          return false;
        return true;
      }
      static q4d(seen0, response_type, scope, redirect_uri, client_id, state, response_mode, access_type, include_granted_scopes, prompt, login_hint, sessionExpiration, serializationConstructorMarker) {
        Companion_getInstance_5();
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_4().d4d_1);
        }
        var $this = createThis(this);
        $this.f4d_1 = response_type;
        $this.g4d_1 = scope;
        $this.h4d_1 = redirect_uri;
        $this.i4d_1 = client_id;
        if (0 === (seen0 & 16))
          $this.j4d_1 = Companion_getInstance().k2p().toString();
        else
          $this.j4d_1 = state;
        if (0 === (seen0 & 32))
          $this.k4d_1 = OauthResponseMode_form_post_getInstance();
        else
          $this.k4d_1 = response_mode;
        if (0 === (seen0 & 64))
          $this.l4d_1 = null;
        else
          $this.l4d_1 = access_type;
        if (0 === (seen0 & 128))
          $this.m4d_1 = null;
        else
          $this.m4d_1 = include_granted_scopes;
        if (0 === (seen0 & 256))
          $this.n4d_1 = null;
        else
          $this.n4d_1 = prompt;
        if (0 === (seen0 & 512))
          $this.o4d_1 = null;
        else
          $this.o4d_1 = login_hint;
        if (0 === (seen0 & 1024))
          $this.p4d_1 = null;
        else
          $this.p4d_1 = sessionExpiration;
        return $this;
      }
    }
    initMetadataForClass($, 'OauthCodeRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
    OauthCodeRequestClass = $;
  }
  return OauthCodeRequestClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.u3j_1.f2();
}
function OauthPromptType$Companion$_anonymous__wqg36u() {
  return createSimpleEnumSerializer('com.lightningkite.lightningserver.auth.oauth.OauthPromptType', values());
}
var OauthPromptType_consent_instance;
var OauthPromptType_select_account_instance;
var OauthPromptType_none_instance;
function values() {
  return [OauthPromptType_consent_getInstance(), OauthPromptType_select_account_getInstance(), OauthPromptType_none_getInstance()];
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      constructor() {
        Companion_instance_6 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.u3j_1 = lazy(tmp_0, OauthPromptType$Companion$_anonymous__wqg36u);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  OauthPromptType_initEntries();
  if (Companion_instance_6 === VOID)
    new (Companion_5())();
  return Companion_instance_6;
}
var OauthPromptType_entriesInitialized;
function OauthPromptType_initEntries() {
  if (OauthPromptType_entriesInitialized)
    return Unit_instance;
  OauthPromptType_entriesInitialized = true;
  OauthPromptType_consent_instance = OauthPromptType().t4d('consent', 0);
  OauthPromptType_select_account_instance = OauthPromptType().t4d('select_account', 1);
  OauthPromptType_none_instance = OauthPromptType().t4d('none', 2);
  Companion_getInstance_6();
}
var OauthPromptTypeClass;
function OauthPromptType() {
  if (OauthPromptTypeClass === VOID) {
    class $ extends Enum() {
      static t4d(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'OauthPromptType', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_6});
    OauthPromptTypeClass = $;
  }
  return OauthPromptTypeClass;
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.v3j_1.f2();
}
function OauthResponseMode$Companion$_anonymous__ampyuk() {
  return createSimpleEnumSerializer('com.lightningkite.lightningserver.auth.oauth.OauthResponseMode', values_0());
}
var OauthResponseMode_form_post_instance;
var OauthResponseMode_query_instance;
function values_0() {
  return [OauthResponseMode_form_post_getInstance(), OauthResponseMode_query_getInstance()];
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      constructor() {
        Companion_instance_7 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.v3j_1 = lazy(tmp_0, OauthResponseMode$Companion$_anonymous__ampyuk);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_7;
function Companion_getInstance_7() {
  OauthResponseMode_initEntries();
  if (Companion_instance_7 === VOID)
    new (Companion_6())();
  return Companion_instance_7;
}
var OauthResponseMode_entriesInitialized;
function OauthResponseMode_initEntries() {
  if (OauthResponseMode_entriesInitialized)
    return Unit_instance;
  OauthResponseMode_entriesInitialized = true;
  OauthResponseMode_form_post_instance = OauthResponseMode().w4d('form_post', 0);
  OauthResponseMode_query_instance = OauthResponseMode().w4d('query', 1);
  Companion_getInstance_7();
}
var OauthResponseModeClass;
function OauthResponseMode() {
  if (OauthResponseModeClass === VOID) {
    class $ extends Enum() {
      static w4d(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'OauthResponseMode', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_7});
    OauthResponseModeClass = $;
  }
  return OauthResponseModeClass;
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.w3j_1.f2();
}
function OauthAccessType$Companion$_anonymous__xa42xm() {
  return createSimpleEnumSerializer('com.lightningkite.lightningserver.auth.oauth.OauthAccessType', values_1());
}
var OauthAccessType_online_instance;
var OauthAccessType_offline_instance;
function values_1() {
  return [OauthAccessType_online_getInstance(), OauthAccessType_offline_getInstance()];
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      constructor() {
        Companion_instance_8 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.w3j_1 = lazy(tmp_0, OauthAccessType$Companion$_anonymous__xa42xm);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_1(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  OauthAccessType_initEntries();
  if (Companion_instance_8 === VOID)
    new (Companion_7())();
  return Companion_instance_8;
}
var OauthAccessType_entriesInitialized;
function OauthAccessType_initEntries() {
  if (OauthAccessType_entriesInitialized)
    return Unit_instance;
  OauthAccessType_entriesInitialized = true;
  OauthAccessType_online_instance = OauthAccessType().z4d('online', 0);
  OauthAccessType_offline_instance = OauthAccessType().z4d('offline', 1);
  Companion_getInstance_8();
}
var OauthAccessTypeClass;
function OauthAccessType() {
  if (OauthAccessTypeClass === VOID) {
    class $ extends Enum() {
      static z4d(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'OauthAccessType', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_8});
    OauthAccessTypeClass = $;
  }
  return OauthAccessTypeClass;
}
function OauthPromptType_consent_getInstance() {
  OauthPromptType_initEntries();
  return OauthPromptType_consent_instance;
}
function OauthPromptType_select_account_getInstance() {
  OauthPromptType_initEntries();
  return OauthPromptType_select_account_instance;
}
function OauthPromptType_none_getInstance() {
  OauthPromptType_initEntries();
  return OauthPromptType_none_instance;
}
function OauthResponseMode_form_post_getInstance() {
  OauthResponseMode_initEntries();
  return OauthResponseMode_form_post_instance;
}
function OauthResponseMode_query_getInstance() {
  OauthResponseMode_initEntries();
  return OauthResponseMode_query_instance;
}
function OauthAccessType_online_getInstance() {
  OauthAccessType_initEntries();
  return OauthAccessType_online_instance;
}
function OauthAccessType_offline_getInstance() {
  OauthAccessType_initEntries();
  return OauthAccessType_offline_instance;
}
//region block: init
Companion_instance_0 = new (Companion())();
Companion_instance_1 = new (Companion_0())();
Companion_instance_4 = new (Companion_3())();
//endregion
//region block: exports
export {
  OauthClientSecret as OauthClientSecret2j9geext0n7q2,
  OauthClient as OauthClientf2xy0pwltr7q,
  Companion_getInstance_8 as Companion_getInstance10khgktosjic0,
  Companion_getInstance_2 as Companion_getInstance3azjmcnlvtkjq,
  Companion_getInstance_3 as Companion_getInstance210kkjgxlt93z,
  Companion_instance_4 as Companion_instance1i62rqxozutzl,
  Companion_getInstance_5 as Companion_getInstanceqngcll8xsq51,
  Companion_getInstance_6 as Companion_getInstance2w2jkppf7qvjb,
  Companion_instance_0 as Companion_instance2q8sycmjnf360,
  Companion_getInstance_7 as Companion_getInstance3jl0ukwxkdn4x,
  Companion_instance_1 as Companion_instance37i54e09zz7vj,
};
//endregion

//# sourceMappingURL=models.mjs.map
